import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

let smoother = {};

export function scrollRefresh() {
     ScrollTrigger.refresh();
}

function parallax() {
     const heroPin = document.querySelector(".pin");

     if (!heroPin) {
          return false;
     }

     const tl = gsap.timeline();

     const top = document.querySelector('.hero__wrapper').clientHeight < window.innerHeight * 0.85 ? -30 : -10

     tl.to(heroPin, { yPercent: top }, 0);

     
          tl.fromTo(heroPin, {
                    clipPath: "polygon(0 0%, 100% 0%, 100% 100%, 0 100%)",
                    webkitClipPath: "polygon(0 0%, 100% 0%, 100% 100%, 0 100%)",
          },{
               
               clipPath: "polygon(0 0%, 100% 0%, 100% 60%, 0 60%)",
               webkitClipPath:  "polygon(0 0%, 100% 0%, 100% 60%, 0 60%)",
          }, 0)
     // }    


     ScrollTrigger.refresh();

     ScrollTrigger.create({
          trigger: heroPin,
          start: "top top",
          end: "+=100%",
          scrub: true,
          pin: true,
          pinSpacing: false,
          pinnedContainer: true,
          animation: tl,
     });


     
     const iconsSection = document.querySelector(".icons-section");
     const iconsSection1 = document.querySelector(".icons-section1");

     const image2 = document.querySelector(".pin2");
     const triggerElement = iconsSection || iconsSection1;

     if (triggerElement) {
          const tl2 = gsap.timeline();
          tl2.from(".list-container", { yPercent: 100, ease: "none" });

          const img2Tl = gsap.timeline()
               .from(image2, {
               clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0 100%)",
               webkitClipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0 100%)",
          });
          ScrollTrigger.create({
               trigger: triggerElement,
               start: "top bottom",
               scrub: true,
               end: "+=200px",
               pinSpacing: false,
               animation: img2Tl,
          });
     }
     const image3 = document.querySelector(".pin3");
     const iconsSection2 = document.querySelector(".icons-section2");
     const triggerElement1 = iconsSection2  ;

     if (triggerElement1) {
          const tl2 = gsap.timeline();
          tl2.from(".list-container", { yPercent: 100, ease: "none" });

          const img3Tl = gsap.timeline().from(image3, {
               clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0 100%)",
               webkitClipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0 100%)",
          })
          .to(image2,{autoAlpha:0},0)
          ScrollTrigger.create({
               trigger: triggerElement1,
               start: "top bottom",
               scrub: true,
               end: "+=200px",
               pinSpacing: false,
               animation: img3Tl,
          });
     }

     

     (function(){
          const videoEl = document.getElementById('video_home');
          if(videoEl){
               ScrollTrigger.create({
                    trigger: videoEl,
                    onLeave:() => {videoEl.pause()},
                    onLeaveBack: () => {videoEl.pause()}
               });
          }
     })()


     // Panels Animation
     function panelsAnimation() {
          const clipAnimate = Array.from(document.querySelectorAll(".clip-animate"));
          if (clipAnimate.length <= 0) {
               return false;
          }
          const panels1Contents = Array.from(clipAnimate[0].querySelectorAll(".design__element path, .inner"));
          const panels2Contents = Array.from(clipAnimate[1].querySelectorAll(".design__element path, .inner"));
          const panels3Contents = Array.from(clipAnimate[2].querySelectorAll(".design__element path, .inner"));

          const panel1Tl = gsap.timeline({
               defaults: {
                    ease: "sine.inOut",
               },
          });
          panel1Tl
               .from(panels1Contents, {
                    xPercent: gsap.utils.wrap([10, 20, 30, 10, -10]),
                    autoAlpha: 0,
                    stagger: 0.05,
               })
               .addLabel("firstout")
               .to(clipAnimate[0], {
                         yPercent: -20,
                         clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
                         webkitClipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
                         ease: "sine.inOut",
               },"firstout");
               
          ScrollTrigger.create({
               trigger: ".panels__wrapper",
               start: "top bottom",
               //           //   end: '50%',
               scrub: true,
               animation: panel1Tl,
          });
          const panelTl = gsap.timeline({
               defaults: {
                    ease: "sine.inOut",
               },
          });

          panelTl

               .from(clipAnimate[1], { scale: 1.2 }, "firstout")
               .from(
                    panels2Contents,
                    {
                         xPercent: gsap.utils.wrap([10, 20, 30, 10, -10]),
                         autoAlpha: 0,
                         stagger: 0.05,
                    },
                    "firstout"
               )
               .addLabel("secondout")
               .to(
                    clipAnimate[1],
                    {
                         yPercent: -20,
                         clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
                         webkitClipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
                         ease: "sine.inOut",
                    },
                    "secondout"
               )
               .to(
                    panels2Contents,
                    { yPercent: -20, autoAlpha: 0, stagger: 0.05 },
                    "secondout"
               )
               .from(clipAnimate[2], { scale: 1.2 }, "secondout")
               .from(
                    panels3Contents,
                    {
                         xPercent: gsap.utils.wrap([10, 20, 30, 10, -10]),
                         autoAlpha: 0,
                         stagger: 0.05,
                    },
                    "secondout"
               );

          ScrollTrigger.create({
               trigger: ".panels__wrapper",
               start: "top top",
               end: "+=200%",
               scrub: true,
               pin: true,
               pinSpacing: true,

               animation: panelTl,
          });

          gsap.set(".clip-animate", {
               zIndex: (i, target, targets) => targets.length - i,
          });
     }

     function scrollIcon() {
          const sIcon = document.querySelector(".field");
          if (sIcon) {
               gsap.to(sIcon, {
                    yPercent: 10,
                    autoAlpha: 0,
                    scrollTrigger: {
                         trigger: ".hero__wrapper",
                         start: "top top",
                         end: "+=40%",
                         scrub: true,
                    },
               });
          }
     }

     scrollIcon();

     ScrollTrigger.matchMedia({
          "(min-width: 760px)": function () {
               // videoAnimation();
               panelsAnimation();
          },
     });

     if (Modernizr.touchevents || Modernizr.forcetouch) {
     } else {
          smoother = ScrollSmoother.create({
               effects: true,
               ignoreMobileResize: true,
               normalizeScroll: true,
               smooth: 2,
               smoothTouch: true,
          });
     }

     function boxAnimation() {
          const col = document.querySelectorAll(".col2");
          if (!col) {
               return false;
          }
          // console.log(col);
          col.forEach((element) => {
               const colimgContainer = element.querySelector(".colimg_container");

               const tl = gsap.timeline({
                    defaults: {
                         ease: "Power1.easeInOut",
                    },
               });
               if (colimgContainer) {
                    const bg = element.querySelector(".bg");
                    let _xPercent = -100;
                    if (bg.classList.contains("bg4") || bg.classList.contains("bg2")) {
                         _xPercent = 100;
                    }
                    tl.set(element, { rotation: 0.01 })
                         .from(bg, { scale: 1.5 }, 0)
                         .from(colimgContainer, { xPercent: _xPercent }, 0);
               }

               ScrollTrigger.create({
                    trigger: element,
                    start: "top 80%",
                    end: "+=50%",
                    scrub: true,
                    animation: tl,
               });
          });
     }

     boxAnimation();
}

export function smootherStop() {
     smoother.paused(!smoother.paused());
}
export default parallax;
